import { useState, useEffect } from 'react';
import api from '../services/api';
import { useAuth } from '../context/AuthContext';

/**
 * 企業一覧を取得するカスタムフック
 * システム管理者のみが企業一覧を取得できます
 */
export const useCompanies = () => {
  const { isSystemAdmin } = useAuth();
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    // システム管理者の場合のみ企業一覧を取得
    if (isSystemAdmin()) {
      fetchCompanies();
    }
  }, []);

  const fetchCompanies = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await api.get('/api/companies/');
      setCompanies(response.data);
    } catch (err) {
      console.error('企業一覧の取得に失敗しました:', err);
      setError(err.response?.data?.detail || '企業一覧の取得に失敗しました');
    } finally {
      setLoading(false);
    }
  };

  return {
    companies,
    loading,
    error,
    refetch: fetchCompanies,
  };
};

export default useCompanies;
